'use client';
import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

// BACKEND INTEGRATION: Replace with GET /api/admin/bookings/weekly-stats
const weeklyData = [
  { day: 'Mon', delhi: 4, outstation: 1 },
  { day: 'Tue', delhi: 6, outstation: 2 },
  { day: 'Wed', delhi: 3, outstation: 3 },
  { day: 'Thu', delhi: 8, outstation: 1 },
  { day: 'Fri', delhi: 11, outstation: 2 },
  { day: 'Sat', delhi: 9, outstation: 4 },
  { day: 'Sun', delhi: 7, outstation: 3 },
];

interface TooltipProps {
  active?: boolean;
  payload?: Array<{ name: string; value: number; color: string }>;
  label?: string;
}

const CustomTooltip = ({ active, payload, label }: TooltipProps) => {
  if (active && payload && payload.length) {
    return (
      <div className="glass-dark border border-border/30 rounded-xl p-3 text-sm">
        <p className="font-bold text-white mb-1">{label}</p>
        {payload.map((p) => (
          <p key={`tip-${p.name}`} style={{ color: p.color }} className="font-semibold">
            {p.name}: {p.value} bookings
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default function AdminBookingsChart() {
  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={weeklyData} margin={{ top: 4, right: 8, left: -20, bottom: 0 }} barCategoryGap="30%">
        <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} />
        <XAxis
          dataKey="day"
          tick={{ fill: 'var(--muted-foreground)', fontSize: 12 }}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          tick={{ fill: 'var(--muted-foreground)', fontSize: 12 }}
          axisLine={false}
          tickLine={false}
        />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(14,165,233,0.06)' }} />
        <Legend
          wrapperStyle={{ fontSize: 12, color: 'var(--muted-foreground)' }}
        />
        <Bar dataKey="delhi" name="Delhi Local" fill="var(--primary)" radius={[4, 4, 0, 0]} />
        <Bar dataKey="outstation" name="Outstation" fill="#7c3aed" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}